import ___default from "lodash";
import moment from "moment";
import { ExperimentStatus } from "../models/AudienceStageModels.js";
import { expressionParser } from "@ane/antlr/lib/FilterExpression/utils/ExpressionParser";
const parseExperiment = (experiment) => {
  const steps = parseExperimentSteps(experiment.experimentSteps);
  const stageStatus = getAggregateStatus(___default.map(steps, (step) => step.status));
  return {
    id: experiment.id,
    name: experiment.displayName,
    description: experiment.description,
    featureId: experiment.featureId,
    status: stageStatus,
    propertyBag: experiment.propertyBag,
    audienceFilters: expressionParser(experiment.audienceFilterExpression),
    audienceFilterExpression: experiment.audienceFilterExpression,
    operations: experiment.operations,
    steps
  };
};
const parseExperimentSteps = (steps) => {
  return ___default.map(steps, (step) => {
    return {
      id: step.id,
      name: step.displayName,
      description: step.description,
      experimentId: step.experimentId,
      startedAt: !!step.startedAt ? moment(step.startedAt).format("lllZ") : null,
      stoppedAt: !!step.stoppedAt ? moment(step.stoppedAt).format("lllZ") : null,
      status: getStepStatus(step),
      variantTrafficMaps: step.variantTrafficMaps
    };
  });
};
const getStepStatus = (step) => {
  if (!step.startedAt && !step.stoppedAt) {
    return ExperimentStatus.NotStarted;
  } else if (!!step.startedAt && !!step.stoppedAt) {
    return ExperimentStatus.Stopped;
  } else {
    return ExperimentStatus.Running;
  }
};
const getAggregateStatus = (statuses) => {
  if (___default.some(statuses, (s) => s === ExperimentStatus.Running)) {
    return ExperimentStatus.Running;
  } else if (___default.some(statuses, (s) => s === ExperimentStatus.Stopped)) {
    return ExperimentStatus.Stopped;
  }
  return ExperimentStatus.NotStarted;
};
export {
  getAggregateStatus,
  getStepStatus,
  parseExperiment,
  parseExperimentSteps
};
//# sourceMappingURL=AudienceStage.utils.js.map
